import { useState, useEffect } from 'react';

export const useSystemTheme = () => {
  const [isDark, setIsDark] = useState(() => {
    // Vérifier les préférences système au chargement initial
    if (typeof window !== 'undefined') {
      return window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    return false;
  });

  useEffect(() => {
    // Créer une media query pour détecter les préférences de couleur système
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    // Fonction pour gérer les changements de préférences système
    const handleChange = (e: MediaQueryListEvent) => {
      setIsDark(e.matches);
    };

    // Écouter les changements de préférences système
    mediaQuery.addEventListener('change', handleChange);

    // Définir l'état initial basé sur les préférences système
    setIsDark(mediaQuery.matches);

    // Nettoyer l'écouteur d'événements
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  // Appliquer le thème au document
  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);

  return { isDark };
};
